__turbopack_context__.v({
  "menu": "dark-header-mobile-module-scss-module__pWOLcq__menu",
  "menu-button": "dark-header-mobile-module-scss-module__pWOLcq__menu-button",
  "menu-item": "dark-header-mobile-module-scss-module__pWOLcq__menu-item",
  "menu-text": "dark-header-mobile-module-scss-module__pWOLcq__menu-text",
  "nav-content": "dark-header-mobile-module-scss-module__pWOLcq__nav-content",
  "navigation": "dark-header-mobile-module-scss-module__pWOLcq__navigation",
});
